import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {AuthService} from '../service/auth.service';
import {JwtTokenModel} from '../service/jwtToken.model';
import {PermissionScope} from '../../../account/modules/user/api/entity/userAccountSummary.model';

@Injectable({ providedIn: 'root' })
export class LoggedUserGuard implements CanActivate {
  constructor(
      private router: Router,
      private authService: AuthService,
  ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return new Promise<boolean>((resolve => {
            const tokenContent: JwtTokenModel = this.authService.tokenContentSnapshot;
            const account = this.authService.account;
            const user = this.authService.user;

            let activated = true;
            if (!tokenContent || !account || !user) {
                activated = false;
                // console.log('No token content');
            } else if (!tokenContent.isStillValid()) {
                activated = false;
                // console.log('Token is not valid');
            }

            if (activated) {
                resolve(true);
            } else {
                this.redirectToLogin(state).finally(() => resolve(false));
            }

        }));
    }


    private redirectToLogin(state: RouterStateSnapshot): Promise<boolean> {
        console.log('redirect to login');
        return this.router.navigate(['/authentication/login'], { queryParams: { returnUrl: state.url } });
    }
}
